import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-banner',
	templateUrl:'./WaBannerPluginCompPage.html',
	styles: [],
	styleUrls:['./WaBannerPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaBannerPluginCompPage
{
	mdContent_1118 = `\`\`\`java
import com.jwebmp.webawesomepro.WaBanner;
\`\`\``;
	mdContent_1119 = `\`\`\`java
new WaBanner&lt;&gt;()
\`\`\``;
}
